
import { Drawer } from "element-ui"
import drawerHeader from "../drawer/components/drawerHeader.vue"
import { getFetchUrl, fetchScript, initBindCardSource } from "./bind-card.js"
import bindCard from "./bind-card.vue"

export default {
  components: {
    [Drawer.name]: Drawer,
    bindCard,
    drawerHeader
  },
  props: {
    payItemInfoList: {
      type: Array,
      default: () => []
    },
    promotionEnjoy: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      active: "",
      visible: false,
      bindCardStatus: "init"
    }
  },
  // watch: {
  //   active: {
  //     handler(newVal) {
  //       this.$emit('card-changed', newVal);
  //     },
  //     immediate: true
  //   },
  // },
  computed: {
    btnText() {
      return this.bindCardStatus === "init" ? this.$t("checkout.next") : this.$t("checkout.payNow")
    },
    cardTitle() {
      let title = ""
      if (this.bindCardStatus === "init") {
        title = this.$t("checkout.addNewCard")
      } else if (this.bindCardStatus === "beforeVerify") {
        title = this.$t("checkout.orderReview")
      } else if (this.bindCardStatus === "verifying") {
        title = this.$t("checkout.DSecureAuth")
      }
      return title
    }
  },
  mounted() {
    const unwatch = this.$watch("payItemInfoList", function (newVal, oldVal) {
      if (newVal && newVal.length) {
        const item = newVal.find(v => v.defaultChosenCard)
        if (item) {
          this.active = item.signNum
        } else {
          this.active = newVal[0].signNum
        }
        this.$emit("card-changed", {
          status: "init",
          payload: this.active
        })
      }
      unwatch()
    })
  },
  methods: {
    handleSelect(val) {
      this.active = val
      this.$emit("card-changed", {
        status: "select",
        payload: val
      })
    },
    handleStatuChanged({ status, payload }) {
      this.bindCardStatus = status
      if (status === "done") {
        this.visible = false
        this.bindCardStatus = "init"
        this.active = payload.signNum
        this.$emit("changed", payload.signNum)
      }
      if (status === "error") {
        this.visible = false
        this.bindCardStatus = "init"
      }
    },
    handleDrawerClose() {
      this.bindCardStatus = "init"
    },
    handleSave() {
      this.$refs.bindCard.onSubmit()
    },
    async handleAddCard() {
      this.loading = true
      await initBindCardSource()
      this.visible = true
      this.loading = false
    },
    trackAddPaymentInfo() {
      this.$emit("trackAddPaymentInfo")
    }
  }
}
